import { Link } from 'react-router-dom'
import { useContacts } from '../hooks/useContacts'

export const EmergencyContactsWidget = () => {
  const { data: contacts = [], isLoading } = useContacts()

  const emergency = contacts.filter((c) => c.is_emergency).slice(0, 3)

  if (isLoading || emergency.length === 0) return null

  return (
    <div className="mb-4">
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-xs font-semibold text-text-muted uppercase tracking-wider">Emergency Contacts</h2>
        <Link to="/contacts" className="text-xs text-primary font-medium">View all</Link>
      </div>
      <div className="bg-surface rounded-base shadow-card overflow-hidden">
        {emergency.map((c, i) => {
          const fullName = [c.first_name, c.last_name].filter(Boolean).join(' ')
          return (
            <Link
              key={c.id}
              to="/contacts"
              className={`flex items-center justify-between px-4 py-3 hover:bg-background transition-colors ${i < emergency.length - 1 ? 'border-b border-border' : ''}`}
            >
              <div className="flex items-center gap-3 min-w-0">
                <div className="w-8 h-8 rounded-full bg-rose-100 flex items-center justify-center flex-shrink-0">
                  <svg className="w-4 h-4 text-rose-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                  </svg>
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-text-primary truncate">{fullName}</p>
                  {c.organization && (
                    <p className="text-xs text-text-muted truncate">{c.organization}</p>
                  )}
                </div>
              </div>
              {c.phone_primary && (
                <a
                  href={`tel:${c.phone_primary}`}
                  onClick={(e) => e.stopPropagation()}
                  className="text-xs text-primary font-medium flex-shrink-0 ml-2"
                >
                  {c.phone_primary}
                </a>
              )}
            </Link>
          )
        })}
      </div>
    </div>
  )
}
